import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { MonitoringGroupedPartRow } from "./monitoring-grouped-parts.types";

@Component({
  selector: "app-monitoring-grouped-parts-table",
  imports: [UiKitModule, CommonModule],
  templateUrl: "./monitoring-grouped-parts-table.component.html",
  styleUrl: "./monitoring-grouped-parts-table.component.scss",
  standalone: true,
})
export class MonitoringGroupedPartsTableComponent {
  @Input() rows: MonitoringGroupedPartRow[] = [];
  @Input() showCategory = true;
  protected readonly tooltipTextWarningSign: string = $localize`:@@productlist.table.warningSign.tooltip:Produkt enthält abgekündigte Komponenten oder ist Teil einer unvollständigen Konfiguration`;
}
